import { render } from "./BulletsList.vue?vue&type=template&id=1f370240"
import script from "./BulletsList.vue?vue&type=script&lang=js"
export * from "./BulletsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__